export enum ECommentType {
  CREATION_WITH_RATING = 10001,
  CREATION = 10002,
  CHAPTER = 10101,
  DANMAKU = 10102,
  REPLY = 11000,
}

// The backend accepts extensible strings; this union represents the statuses currently supported by the UI.
export type TReadingStatus = "Want to Read" | "Reading" | "Read" | "Paused" | "Abandoned";
export type TMyRatingComment = {
  id: string;
  root_id: string;
  rating: number;
  user_status?: TReadingStatus | "";
  content?: string;
  data?: Record<string, unknown>;
  created_at?: string;
  updated_at?: string;
};

export type TUpdateReadingStatusParams = {
  root_id: string;
  // An empty string clears the user's current reading status.
  user_status: TReadingStatus | "";
};

// A 10001 record can exist only to store reading status, so its ID alone does not mean it has a rating or review.
export const hasRatingOrReview = (comment?: Partial<TMyRatingComment> | null): boolean =>
  (typeof comment?.rating === "number" && comment.rating >= 0) || Boolean(comment?.content?.trim());
